<div
  class="estimate-template-menu"
  fxLayout="column"
  fxLayoutGap="0.5rem"
  data-estimate-template-menu
>
  @if (breadcrumbs(); as trail) {
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="4px"
      class="estimate-template-menu__breadcrumbs"
    >
      <button
        mat-button
        type="button"
        (click)="resetCategory()"
        class="estimate-template-menu__breadcrumb-btn"
        data-template-breadcrumb-root
      >
        {{ 'common.all' | translate }}
      </button>

      @for (breadcrumb of trail; track breadcrumb.id; let index = $index) {
        <mat-icon class="estimate-template-menu__breadcrumb-icon">chevron_right</mat-icon>
        @if (index < trail.length - 1) {
          <button
            mat-button
            type="button"
            (click)="selectBreadcrumb(index)"
            class="estimate-template-menu__breadcrumb-btn"
            data-template-breadcrumb
          >
            {{ breadcrumb.name }}
          </button>
        } @else {
          <span data-template-breadcrumb-current>{{ breadcrumb.name }}</span>
        }
      }
    </div>
  }

  <mat-form-field subscriptSizing="dynamic">
    <input matInput [formControl]="filterCtrl" data-template-search />
  </mat-form-field>

  <div fxLayout="column" fxLayoutGap="4px" class="estimate-template-menu__list">
    @if (categoriesLoading() || templatesLoading()) {
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="estimate-template-menu__loading"
        data-template-loading
      >
        <mat-spinner diameter="24" [strokeWidth]="2"></mat-spinner>
      </div>
    }

    @for (category of visibleCategories(); track category.id) {
      <button
        mat-button
        type="button"
        (click)="selectCategory(category)"
        [disabled]="categoriesLoading() || templatesLoading()"
        class="estimate-template-menu__list-item"
        data-template-category
      >
        <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <mat-icon color="primary">folder</mat-icon>
          <span>{{ category.name }}</span>
        </span>
      </button>
    }

    @for (template of visibleTemplates(); track template.id) {
      <button
        mat-button
        type="button"
        (click)="pickTemplate(template.id)"
        [disabled]="categoriesLoading() || templatesLoading()"
        class="estimate-template-menu__list-item"
        data-template-row
        [attr.data-template-id]="template.id"
      >
        <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <mat-icon color="primary">description</mat-icon>
          <span>{{ template.name }}</span>
        </span>
      </button>
    }

    @if (visibleCategories().length === 0 && visibleTemplates().length === 0 && !categoriesLoading() && !templatesLoading()) {
      <span class="text-muted" data-template-empty>
        {{ 'dialog.charges.not-found' | translate }}
      </span>
    }
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
    class="estimate-template-menu__actions-bar"
  >
    <button
      *appHasPermission="'estimate-category.create'"
      mat-stroked-button
      type="button"
      [disabled]="categoriesLoading() || templatesLoading()"
      [matTooltip]="('common.add' | translate) + ' ' + ('common.category' | translate)"
      (click)="openNewCategoryDialog()"
      data-template-add-category
    >
      <mat-icon>add</mat-icon>
      <span>{{ 'common.category' | translate }}</span>
    </button>
    <button
      *appHasPermission="'estimate-template.create'"
      mat-stroked-button
      type="button"
      [disabled]="categoriesLoading() || templatesLoading()"
      [matTooltip]="('common.add' | translate) + ' ' + ('common.template' | translate)"
      (click)="openNewTemplateDialog()"
      data-template-add-template
    >
      <mat-icon>add</mat-icon>
      <span>{{ 'common.template' | translate }}</span>
    </button>
  </div>
</div>
